import { setRegisteredData } from "./forms/registered-data";

$('[name="personal_data[billType]"]').on('change', function() {
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');

$('[name="personal_data[emailRepeat]"]').each(function() {
    let $email = $('[name="personal_data[email]"]', this.form.elements);
    let $emailRepeat = $('[name="personal_data[emailRepeat]"]', this.form.elements);
    $($email).add($emailRepeat).on('input', function() {
        $emailRepeat.toggleValid($email.val() == $emailRepeat.val());
    }).trigger('change');
});

$('.application-form').on('submit-success', function(event, data) {
    $('.application').removeClass('show');

    $('html, body').animate({
        scrollTop: 0
    }, 300);

    if (data.prize) {
        if (data.prize.staticId === 'mugs') {
            $('.prize-info').text('To był dobry ruch. Wygrałeś zestaw kufli!');
        }
        $('.win-thanks').addClass('show');
        setRegisteredData(data, 'section#win-thanks');
    } else {
        $('.loss-thanks').addClass('show');
        setRegisteredData(data, 'section#loss-thanks');
    }

    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            'event': 'form_sent',
            'page_path': '/',
            'page_title': 'Formularz zgłoszeniowy',
            'form_name': 'Kozel Loteria 2025',
            'receipt_id': data.billNr,
            'vote_status': data.prize ? 'true' : 'false',
            'reward': data.prize ? 'Kufle' : '',
            'client_id': data.uuid,
        });
    }
});

$('.application-form').on('submit-error', function(event, data) {
    // if (typeof dataLayer !== 'undefined') {
    //     dataLayer.push({
    //         'event': 'form_error',
    //         'page_path': '/',
    //         'page_title': 'Formularz zgłoszeniowy',
    //         'form_name': 'Kozel Loteria 2025',
    //         'receipt_id': data.billNr,
    //         'vote_status': data.prize ? 'true' : 'false',
    //         'reward': 'Kufle',
    //         'client_id': data.uuid,
    //     });
    // }
});

$('.application-form').on('submit-invalid', function (event, data) {
    if (typeof dataLayer !== 'undefined') {
        let invalidInputs = {};
        const inputs = $('.was-validated').find('input');

        inputs.each((key, input) => {
            const formattedName = $(input).attr('name').replaceAll(/personal_data\[|\]/g, '');
            if ($(input).is(':invalid')) {
                invalidInputs[`${formattedName}_status`] = 'false';
            } else {
                invalidInputs[`${formattedName}_status`] = 'true';
            }
        });
        const eventData = {
            'event': 'form_error',
            'page_path': '/',
            'page_title': 'Formularz zgłoszeniowy',
            'form_name': 'Kozel Loteria 2025',
        };
        dataLayer.push({...eventData, ...invalidInputs});
    }
});

$('.game-run').on('click', function() {
    // page swap
    $('section#application .page').addClass('d-none');
    $('section#application .page-result').removeClass('d-none').css('display', 'block');

    // modal (uncomment if you need modal instead of page swap)
    //$('#modal-form-application').modal('show');
});

$('.result-try-again').on('click', function() {
    $('section#application .page').addClass('d-none');
    $('section#application .page-form').removeClass('d-none');
});

$('[name="personal_data[noPesel]"]').on('change', function() {
    $('[name="personal_data[pesel]"]', this.form.elements).prop('disabled', $(this).prop('checked'));
    let fields = [
        '[name="personal_data[street]"]',
        '[name="personal_data[streetNr]"]',
        '[name="personal_data[flatNr]"]',
        '[name="personal_data[zipCode]"]',
        '[name="personal_data[city]"]',
    ];
    $(fields.join(', '), this.form.elements).closest('.form-group').prop('disabled', !$(this).prop('checked'));
}).trigger('change');

$('.winner-form').on('submit-success', function(event, data) {
    setRegisteredData(data, 'section#winner-thanks');

    // page swap
    $('#winner').remove();
    $('#winner-thanks').removeClass('d-none');
    $('#winner-thanks').addClass('show');

    $('html, body').animate({
        scrollTop: 0
    }, 300);
});

$('.contact-form').on('submit-success', function(event, data) {
    // page swap
    $('.page').addClass('d-none');
    $('.page-thank-you').removeClass('d-none');
    $('.page-thank-you').css('display', 'block');
});
